module.exports = __webpack_public_path__ + "static/media/table_color.b6d8008f.svg";